import React, { memo } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import EvalList from "./EvalList";

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(6),
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(2),
    },
  },
}));

const FormList = memo(({ datas, que, handleChange }) => {
  const classes = useStyles();
  return (
    <>
      <Grid
        container
        justify="space-between"
        alignItems="center"
        className={classes.root}
      >
        {datas.map((data) => (
          <EvalList
            data={data}
            que={que}
            handleChange={handleChange}
            key={data.no}
          />
        ))}
      </Grid>
    </>
  );
});

export default FormList;
